import { TagGroup_Prefix } from '../models/enum/shared/section-theme-tag-group-keys';

export class RegexUtils {
  static readonly energyScoreRegex = new RegExp(/^EnergyScore_(\d|10)$/);
  static readonly productTagGroupRegex = new RegExp(`^${TagGroup_Prefix}(.+)$`);
  static readonly cheapWeedRegex = /cheap[^a-z]*weed/;
  static readonly parseNumbers = /(\d+\.?\d*)/g;
}
